/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11 10.9999L9.80756 15.6056M6.77661 13.0877C5.5 9.49989 8.5 6.44434 11.9999 6.44434C15.0677 6.44434 17.5 8.73877 17.5 11.4999C17.5 15.4707 12.9896 17.7156 9.80756 15.6056M9.80756 15.6056L8.3285 21.3042"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19.059 19.0711C22.9803 15.1658 22.9803 8.83419 19.059 4.92894C15.1377 1.02369 8.78005 1.02369 4.85875 4.92894C-0.187456 9.95445 1.75408 18.7466 8.27229 21.3043C11.8792 22.7197 16.1428 21.9753 19.059 19.0711Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<circle opacity="0.12" cx="12" cy="12" r="10" fill="currentColor" />
			<path
				d="M11 11L9.80756 15.6057M6.7766 13.0878C5.5 9.5 8.5 6.44445 11.9999 6.44445C15.0677 6.44445 17.5 8.73889 17.5 11.5C17.5 15.4708 12.9896 17.7157 9.80756 15.6057M9.80756 15.6057L8.3285 21.3043M8.3285 21.3043C11.9207 22.7197 16.1668 21.9753 19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92894C15.1658 1.02369 8.83418 1.02369 4.92894 4.92894C1.02369 8.83416 1.02369 15.1658 4.92894 19.0711C5.92994 20.0721 7.09037 20.8165 8.3285 21.3043Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C10.8981 22.75 9.8349 22.5842 8.83402 22.2762L10.2917 16.7164C13.8451 18.2362 18.25 15.7304 18.25 11.5C18.25 8.27186 15.4271 5.69446 11.9999 5.69446C10.0375 5.69446 8.20047 6.54931 7.02501 7.93568C5.83515 9.33904 5.33652 11.2778 6.07 13.3392C6.20886 13.7295 6.63778 13.9333 7.02803 13.7944C7.41827 13.6555 7.62207 13.2266 7.48321 12.8364C6.94009 11.31 7.30316 9.92709 8.16913 8.90573C9.04951 7.86738 10.4624 7.19446 11.9999 7.19446C14.7084 7.19446 16.75 9.20593 16.75 11.5C16.75 14.6623 13.3356 16.5593 10.6763 15.2425L11.7261 11.188C11.8299 10.787 11.589 10.3778 11.188 10.2739C10.787 10.1701 10.3778 10.411 10.2739 10.812L9.08208 15.4155L9.0815 15.4177L7.4262 21.7313C3.77635 20.0128 1.25 16.3014 1.25 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M11 11L9.80756 15.6057M6.7766 13.0878C5.5 9.5 8.5 6.44445 11.9999 6.44445C15.0677 6.44445 17.5 8.73889 17.5 11.5C17.5 15.4708 12.9896 17.7157 9.80756 15.6057M9.80756 15.6057L8.3285 21.3043C7.09037 20.8165 5.92994 20.0721 4.92894 19.0711C1.02369 15.1658 1.02369 8.83416 4.92894 4.92894C8.83418 1.02369 15.1658 1.02369 19.0711 4.92894C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711C17.1184 21.0237 14.5592 22 11.9999 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11 11L9.80756 15.6057M6.7766 13.0878C5.5 9.5 8.5 6.44445 11.9999 6.44445C15.0677 6.44445 17.5 8.73889 17.5 11.5C17.5 15.4708 12.9896 17.7157 9.80756 15.6057M9.80756 15.6057L8.3285 21.3043M8.3285 21.3043C11.9207 22.7197 16.1668 21.9753 19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92894C15.1658 1.02369 8.83418 1.02369 4.92894 4.92894C1.02369 8.83416 1.02369 15.1658 4.92894 19.0711C5.92994 20.0721 7.09037 20.8165 8.3285 21.3043Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.16917 8.90561C7.3032 9.92697 6.94013 11.3099 7.48325 12.8363C7.62211 13.2265 7.41832 13.6554 7.02807 13.7943C6.63783 13.9331 6.2089 13.7293 6.07005 13.3391C5.33656 11.2777 5.8352 9.33892 7.02506 7.93556C8.20051 6.54919 10.0376 5.69434 12 5.69434C15.4271 5.69434 18.25 8.27173 18.25 11.4999C18.25 15.7294 13.847 18.235 10.2939 16.7172L9.05449 21.4927C8.95043 21.8936 8.54106 22.1342 8.14013 22.0302C7.7392 21.9261 7.49854 21.5167 7.6026 21.1158L9.08154 15.4176L9.08166 15.4172L10.274 10.8119C10.3778 10.4109 10.787 10.17 11.188 10.2738C11.589 10.3776 11.8299 10.7869 11.7261 11.1879L10.6764 15.2424C13.3357 16.5591 16.75 14.6621 16.75 11.4999C16.75 9.20581 14.7084 7.19434 12 7.19434C10.4625 7.19434 9.04955 7.86726 8.16917 8.90561Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
